<template>
  <main class="l-main-no-bottom-padding">
    <content-home-mantle />
    <customer-forms class="home-index__customer-forms" />
    <content-section-alpha class="home-index__content-section" />
    <content-section-bravo class="home-index__content-section home-index__content-section--margin-bottom-0" />
    <content-section-grad-stats class="home-index__content-section" />
    <content-section-clients class="home-index__content-section" />
    <content-section-client-testimonials class="home-index__content-section home-index__content-section--margin-bottom-3" />
    <content-section-charlie class="home-index__content-section  home-index__content-section--margin-bottom-0" />
  </main>
</template>

<script>
import ContentHomeMantle from './components/ContentSections/HomeMantle.vue'
import ContentSectionAlpha from './components/ContentSections/Alpha.vue'
import ContentSectionBravo from './components/ContentSections/Bravo.vue'
import ContentSectionCharlie from './components/ContentSections/Charlie.vue'

import ContentSectionClients from './components/ContentSections/Clients.vue'
import ContentSectionGradStats from './components/ContentSections/GradStats.vue'
import ContentSectionClientTestimonials from './components/ContentSections/ClientTestimonials.vue'

import CustomerForms from './components/CustomerForms/CustomerForms.vue'

export default {
  name: 'HomeIndexApp',
  components: {
    ContentHomeMantle,
    ContentSectionAlpha,
    ContentSectionBravo,
    ContentSectionClients,
    ContentSectionClientTestimonials,
    ContentSectionCharlie,
    ContentSectionGradStats,
    CustomerForms
  },
  computed: {
    content () {
      return this.$store.state.pageContent
    }
  }
}
</script>

<style lang="scss" scoped>
@include circularstd-fontface("../../../shared/fonts");

.home-index {
  &__customer-forms {
    margin-bottom: 5rem;
  }

  &__content-section {
    margin-bottom: 5rem;

    &--margin-bottom-3 {
      margin-bottom: 3rem;
    }

    &--margin-bottom-0 {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/pictureday/home/index/App.vue